import { Tooltip as AntdTooltip, TooltipProps } from 'antd';
import { FunctionComponent } from 'react';

export type { TooltipProps };

export const Tooltip: FunctionComponent<TooltipProps> = ({
  children,
  rootClassName,
  ...rest
}) => {
  return (
    <AntdTooltip className="the5ers-tooltip" {...rest}>
      <div className={rootClassName}>{children}</div>
    </AntdTooltip>
  );
};
